<template>
  <transition name="modal">
    <div class="modalcon">
      <div class="modal-mask" @click="closeModal">
        <div class="modal-wrapper">
          <div class="modal-container" @click.stop>
            <span class="closebtn" @click="closeModal">
              <i class="fa fa-close" aria-hidden="true"></i>
            </span>
            <div class="clearfix"></div>
            <div class="mbox">
              <div class="modal-header prelative">
                <img data-src="https://tss-static-images.gumlet.io/exclusive/NotifyLogo.png" class="notify-logo" alt="TSS Exclusive Logo"/>
              </div>
              <div class="modal-body mb0">
                <div class="congratulations text-center fbold">Congratulations!</div>
                <div class="notify-title">The Exclusive membership has been added to your cart at an introductory price of <span class="fbold">₹ 199 </span> / year</div>
                <div class="fbold text-center benefits">BENEFITS</div>
                <ul>
                  <li>BIG discounts on all products</li>
                  <li>Prioritised order processing</li>
                  <li>Free shipping on all orders</li>
                  <li>Early access to some of our latest products</li>
                </ul>
                <button type="submit" class="btn btn-primary btn-block text-uppercase btn-notify pointer" @click="closeModal">Continue Shopping</button>
                <div class="info text-center" style="margin: 0; margin-bottom: 20px;">If you reeaaallly want to know more, <router-link to="/exclusive" target="_blank" rel="noopener noreferrer">Click Here</router-link></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
  var $ = require('jquery')
  window.jQuery = $
  import SimpleVueValidation from 'simple-vue-validator'

  var Validator = SimpleVueValidation.Validator
  export default {
    data () {
      return {
        email: '',
        error: ''
      }
    },
    props: ['closeModal'],
    validators: {
      email: function (value) {
        return Validator.value(value).required('Please enter your e-mail ID').email('Please enter a valid e-mail ID')
      }
    },
    methods: {
      notifyMe () {
        this.$validate().then((success) => {
          if (success) {
            this.$store.dispatch('NOTIFY_ME', {email: this.email})
          }
        })
      },
      escapeKeyPressHandler (e) {
        if (e.keyCode === 27) {
          this.closemodal()
        }
      }
    },
    created () {
      $('body').addClass('_freeze')
    },
    mounted () {
      document.body.addEventListener('keyup', e => this.escapeKeyPressHandler(e))
    },
    beforeDestroy () {
      $('body').removeClass('_freeze')
    }
  }
</script>

<style lang="css" scoped>
  .modal-header {
    border: none;
  }

  .notify-logo {
    margin: 0 auto;
    height: 120px;
    margin-top: -74px;
  }

  .btn-notify {
    letter-spacing: 1px;
    margin: 0 auto;
    margin-top: 15px;
    width: 200px;
  }

  .closebtn {
    background: #90050d;
    border-radius: 24px;
    padding: 2px 7px;
    color: #fff;
    position: absolute;
    margin-top: -12px;
    right: -12px;
    cursor: pointer;
  }

  .closebtn:hover {
    background: #73040a;
  }

  .congratulations {
    color: #73040a;
    font-size: 25px;
  }

  .notify-title {
    text-align: center;
    margin-top: 10px;
    font-size: 18px;
    line-height: 22px;
    color: #555;
    margin-bottom: 18px;
  }

  .benefits {
    color: #90050d;
    font-size: 18px;
    margin-bottom: 12px;
  }

  .info {
    font-size: 14px;
    margin-left: 20px;
  }

  .modalcon {
    position: fixed;
    display: block;
    left: 0;
    z-index: 9998;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    overflow-x: hidden;
    overflow-y: auto;
    transition: opacity .3s ease;
  }

  .modal-mask {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: table;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }

  .modal-container {
    width: 500px;
    margin: 0px auto;
    transition: all .3s ease;
    position: relative;
  }

  .error {
    text-align: left;
  }

  .mbox {
    background: #fff;
    padding: 10px;
    padding-bottom: 0;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  }

  .modal-header,
  .modal-body {
    padding: 5px;
  }

  .modal-enter {
    opacity: 0;
  }

  .modal-enter .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }

  form {
    width: 100%;
    max-width: 400px;
    margin: 0 auto;
  }

  .btn {
    margin-bottom: 15px;
  }

  .notify-message {
    color: #90050d;
    margin-bottom: 10px;
  }

  .form-control, .btn {
    border-radius: 4px;
  }

  @media screen and (max-width: 768px) {
    .modal-container {
      width: 92%;
    }
  }

  @media screen and (max-width: 480px) {
    .notify-title {
      font-size: 14px;
      line-height: 18px;
      margin-bottom: 10px;
      margin-top: 5px;
    }
    ul {
      font-size: 14px;
      margin-bottom: 10px;
    }
    .btn {
      margin-top: 15px;
      margin-bottom: 10px;
    }
    .congratulations {
      font-size: 22px;
    }
    .benefits {
      margin-bottom: 8px;
    }
    .mbox {
      padding: 0;
    }
    .notify-logo {
      height: 84px;
      margin-top: -40px;
    }
  }
</style>



// WEBPACK FOOTER //
// NotifyModal.vue?79e8a799